module.exports = __webpack_public_path__ + "img/main-icon-color.bcbfe400.png";